export const urlDetails = (url) => {
  // const link = new URL(url);
  // const port = `:${link.port}`;
  const port = null;
  // const path = link.pathname.slice(1);
  const path = url;
  return { port, path };
}
export const baseUrl = process.env.REACT_APP_CMS_API_URL
